function getSourceBuffer() {
  return window.self.SourceBuffer || window.self.WebKitSourceBuffer;
}

export function getMediaSource() {
    if (typeof window.self === 'undefined') return undefined;
    return window.self.MediaSource || window.self.WebKitMediaSource;
}

  export function isSupported() {
    const mediaSource = getMediaSource();
    if (!mediaSource) {
      return false;
    }
    const sourceBuffer = getSourceBuffer();
    const isTypeSupported =
      mediaSource &&
      typeof mediaSource.isTypeSupported === 'function' &&
      mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
  
    const sourceBufferValidAPI =
      !sourceBuffer ||
      (sourceBuffer.prototype &&
        typeof sourceBuffer.prototype.appendBuffer === 'function' &&
        typeof sourceBuffer.prototype.remove === 'function');
    return !!isTypeSupported && !!sourceBufferValidAPI;
  }